/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/
 
/********************************************************************
 * Configuration for "local" environment 
 ********************************************************************/
 'use strict';

 // Import local configuration and override
 var config = require('./base');
 
 config.app.zendeskBasePathEN = "https://cambridgeonehelp.cambridge.org/hc/en-gb";
 config.app.zendeskBasePathES = "https://cambridgeonehelp.cambridge.org/hc/es-es";
 config.app.ieltsConfig.miniTestTypes = {
    '0abd07c1-7829-1190-2d33-d8af40123b3d': {
        items: 30,
        price: '7.99',
        time: '40',
        key: 'IELTSi30',
        title: 'IELTSi 30',
        sapId: '2800465042'
    },
    'dabd07c1-72f2-2083-6e1e-522b5b94c724': {
        items: 8,
        price: '1.99',
        time: '15',
        key: 'IELTSi8',
        title: 'IELTSi 8',
        sapId: '2800484745' 
    },
    '60bd07c1-6db5-b79d-839a-a4cce5f15e7b': {
        items: 4,
        price: '0.99',
        time: '5',
        key: 'IELTSi4',
        title: 'IELTSi 4',
        sapId: '2800484748' 
    }
}
 module.exports = config;
 